/**
 * Created by Mehraz on 2022-02-22.
 */
import router from '../../router'
import {addDoc, collection, doc, getDoc, setDoc, updateDoc} from "firebase/firestore";
import {getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signInAnonymously, signOut} from "firebase/auth";
export default {
  state: {
    user: null,
    anonQuoteDetails: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setAnonQuoteDetails (state, payload) {
        state.anonQuoteDetails = payload
    }
  },
  actions: {
      signUserIn ({commit, rootState, dispatch}, payload) {
      commit('setLoading', true)
      commit('clearError')
      let auth = getAuth()
      signInWithEmailAndPassword(auth, payload.email, payload.password)
          .then(user => {
            commit('setLoading', false)
              dispatch('fetchUserData', {uid: user.user.uid})
            let db = rootState.db
            return addDoc(collection(db, 'users', user.user.uid, 'logins'), {
              ...user.user.reloadUserInfo}, { merge: true })
          })
          .catch(error => {
                console.log(error)
                commit('setLoading', false)
                commit('setError', error)
              }
          )
    },
      signupAnon ({commit, dispatch, rootState}) {
          let auth = getAuth()
          let user
          signInAnonymously(auth)
              .then((userCredential) => {
                  // Signed in..
                  //console.log(userCredential)
                  user = userCredential.user;
                  let db = rootState.db
                  let userObj = {
                      isAnonymous: true,
                      uid: user.uid,
                      created: Date.now()
                  }
                  commit('setUser', userObj)
                  return setDoc(doc(db, 'anonUsers', user.uid), userObj, { merge: true })
              })
              .then(() => {
                  dispatch('fetchAnonUserData', {uid: user.uid})
                  commit('setLoading', false)
              })
              .catch((error) => {
                  const errorMessage = error.message;
                  commit('setError', errorMessage)
              });
      },
      fetchAnonUserData ({commit, rootState}, payload) {
          commit('setLoading', true)
          let userProfile = {}
          let userRef = doc(rootState.db, 'anonUsers', payload.uid)
          getDoc(userRef)
              .then(doc => {
                  if (doc.exists) {
                      const data = doc.data()
                      userProfile = {
                          ...data
                      }
                      commit('setUser', userProfile)
                  }
                  // commit('setLoading', false)
              })
              .then (()=> {
                  if (!userProfile.uid) {
                      userProfile.uid = payload.uid
                      userProfile.created = Date.now()
                      userProfile.isAnonymous = true
                      commit('setUser', userProfile)
                      return setDoc(userRef, userProfile)
                  }
              })
              .catch(error => {
                  console.log(error)
                  commit('setError', error)
                  commit('setLoading', false)
              })
      },
      setAnonUserData ({commit}, payload) {
          commit('setUser', payload)
          commit('setAnonQuoteDetails', payload)
      },
      fetchUserData ({commit, rootState}, payload) {
        commit('setLoading', true)
        let userProfile = {}
          let userRef = doc(rootState.db, 'customers', payload.uid)
        getDoc(userRef)
            .then(doc => {
                //console.log(payload.uid)
            if (doc.exists) {
                const data = doc.data()
                userProfile = {
                  ...data,
                }
                commit('setUser', userProfile)
            }
                // commit('setLoading', false)
            })
            .then (()=> {
                if (!userProfile.uid) {
                    userProfile.uid = payload.uid
                    userProfile.created = Date.now()
                    commit('setUser', userProfile)
                    return setDoc(userRef, userProfile)
                }
            })
            .catch(error => {
                console.log(error)
                commit('setError', error)
                commit('setLoading', false)
        })
    },
      setUserData ({commit}, payload) {
          commit('setUser', payload)
      },
      onSignUp ({rootState, commit, dispatch}, payload) {
        let userInfo = {name: payload.name, email: payload.email, password: payload.password}
        let auth = getAuth()
        let user
        commit('setLoading', true)
        createUserWithEmailAndPassword(auth, userInfo.email, userInfo.password)
            .then((userCredential) => {
                // Signed in
                user = userCredential.user;
                let db = rootState.db
                let userObj = {
                    uid: user.uid,
                    name: userInfo.name,
                    email: userInfo.email
                }
                commit('setUser', userObj)
                return setDoc(doc(db, 'users', user.uid), userObj, { merge: true })
            })
            .then(() => {
                dispatch('fetchUserData', {uid: user.uid})
                router.push('/')
                commit('setLoading', false)
            })
            .catch((error) => {
                commit('setLoading', false)
                commit('setError', error)
                console.log(error)
            });
      },
      updateUserProfile({commit, rootState}, payload) {
          commit('setLoading', true)
          let userRef = doc(rootState.db, 'customers', payload.uid)
          updateDoc(userRef, payload)
              .then(() => {
                  commit('setLoading', false)
                  commit('setUser', payload)
              })
              .catch(error => {
                  console.log(error)
                  commit('setError', error)
                  commit('setLoading', false)
              })
      },
    clearError ({commit}) {
      commit('clearError')
    },
    logout ({commit}) {
        let auth = getAuth()
        signOut(auth)
            .then(() => {
                console.log('user signed out')
            })

        commit('setUser', null)
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    anonQuoteDetails (state) {
        return state.anonQuoteDetails
    }
  }
}
